import React from "react";
import "./StatsBar.css";

const STATS = [
  { val: "15+", lbl: "Projects Delivered" },
  { val: "30+",  lbl: "Expert Team Members" },
  { val: "100%",  lbl: "Client Satisfaction" },
  { val: "2+",   lbl: "Years of Excellence" },
];

const StatsBar: React.FC = () => (
  <div className="statsbar">
    <div className="container">
      <div className="statsbar__grid">
        {STATS.map((s, i) => (
          <div key={i} className="statsbar__item">
            <span className="statsbar__val">{s.val}</span>
            <span className="statsbar__lbl">{s.lbl}</span>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default StatsBar;
